// Screen `storage` — design/screens/SettingsSystem.dc.html — owner: S11. `?object=` brings an object's row
// into view (the object builder's Behaviour › Storage links here).
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { StoragePage } from '../../../features/ops/StoragePage';

const Search = z.object({ object: z.string().max(63).optional().catch(undefined) });

export const Route = createFileRoute('/_settings/settings/storage')({
  validateSearch: (s) => Search.parse(s),
  component: StorageRoute,
});

function StorageRoute() {
  const { object } = Route.useSearch();
  return <StoragePage object={object} />;
}
